import { useEffect, useState } from "react"
import { Container } from "./styles"
import { IMensagemHistoricoProps } from "./types"
import { MensagemHistory } from "../../models"
import { useTheme } from "styled-components"
import { useNavigate, useParams } from "react-router-dom"
import * as MensagemHistoryService from '../../services/MensagemHistory/MensagemHistoryService'
import { toast } from "react-toastify"
import { errorHandle } from "../../utils/errorHandle"
import Loader from "../../components/Loader"
import Title from "../../components/Title"
import GroupButtons from "../../components/GroupButtons"
import Button from "../../components/Button"
import List from "../../components/List"
import CardMensagemHistory from "../../components/CardMensagemHistory"

const MensagemHistorico: React.FC<IMensagemHistoricoProps> = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [historicos, setHistoricos] = useState<MensagemHistory[]>([])

    const theme = useTheme()
    const navigate = useNavigate()
    const { eventoId, eventoDescricao, convidadoId, convidadoNome} = useParams()

    useEffect(() => {
        getHistoricos()
        // eslint-disable-next-line
    }, [])

    const getHistoricos = async (): Promise<void> => {
        setLoading(true)
        await MensagemHistoryService.getByConvidadoId(convidadoId!)
            .then((res) => {
                setHistoricos(res.data.data)
            })
            .catch((err) => toast.error(errorHandle(err)))
            .finally(() => setLoading(false))
    }

    return(
        <>
            {
                loading
                    ? <Loader />
                    : <Container>
                        <Title color={theme!.colors.warning} size={30}>Histórico de mensagens</Title>
                        <Title color={theme!.colors.info} size={20}>{convidadoNome!}</Title>
                        <GroupButtons>
                            <Button 
                                $backgroundColor={theme!.colors.warning}
                                type='button'
                                onClick={() => navigate(`/convidado/${eventoId}/${eventoDescricao}`)}
                            >
                                Voltar
                            </Button>
                        </GroupButtons>
                        <List>
                            {
                                historicos.map(historico => (
                                    <CardMensagemHistory 
                                        key={historico.id} 
                                        historico={historico}
                                    />
                                ))
                            }
                        </List>
                    </Container>
            }
        </>
    )
}

export default MensagemHistorico